<template>
  <v-container class="listContainer">
    <Loader v-if="isLoading" />
    <Empty v-else-if="Object.keys(token).length === 0 && token.constructor === Object"/>
    <v-card v-else-if="!isLoading">
      <v-toolbar
        dense
        light
        card
      >
        <v-toolbar-title>
          <img class="toolbarIcons" src="@/assets/img/icons/tokens.png" alt="tokens" />
          Token
          <span>
            {{ token.erc20Token.symbol }}
          </span>
            <!-- <img
              class="toolbarIcons copyIcon"
              src="@/assets/img/icons/copy.png"
              alt="copy"
              v-clipboard:copy="token.erc20Token.symbol"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            /> -->
          </v-toolbar-title>
      </v-toolbar>
    <v-container>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Name</v-list-tile-title>
      <v-list-tile-content>{{ token.erc20Token.name }}</v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Contract</v-list-tile-title>
      <router-link class="router-link" :to="{ name: 'address', params: {address: token.erc20Token.address}}">
        <v-list-tile-content>{{ token.erc20Token.address}}</v-list-tile-content>
      </router-link>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Owner</v-list-tile-title>
      <router-link v-if="token.erc20Token.owner && token.erc20Token.owner !== '0x'" class="router-link" :to="{ name: 'address', params: {address: token.erc20Token.owner}}">
        <v-list-tile-content>{{ token.erc20Token.owner }}</v-list-tile-content>
      </router-link>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Total Supply</v-list-tile-title>
      <v-list-tile-content>{{ token.erc20Token.totalSupply }}</v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Decimals</v-list-tile-title>
      <v-list-tile-content>{{ token.erc20Token.decimals }}</v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Transfers</v-list-tile-title>
      <v-list-tile-content>{{ token.transfers }}</v-list-tile-content>
    </v-list-tile>
    <v-tabs
      class="tableTabs nestedTabs"
      slider-color="primary"
    >
      <v-tab>
        Transfers
      </v-tab>
      <v-tab-item>
        <TokenTransfers v-bind:address="token.erc20Token.address"/>
      </v-tab-item>
    </v-tabs>
    </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import TokenTransfers from './tokenTransfers.vue';
import toast from '../../tools/toast';
import Loader from '../reusables/loader.vue';
import Empty from "../reusables/empty.vue";

export default {
  name: 'AddressContainer',
  computed: {
    ...mapGetters(['token']),
  },
  components: {
    TokenTransfers,
    Loader,
    Empty
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    '$route.params.token'(newToken, oldToken) {
      this.fetchData(newToken);
    },
    token() {
      this.isLoading = false;
    },
  },
  created() {
    this.fetchData(this.$route.params.token);
  },
  methods: {
    fetchData(token) {
      this.isLoading = true;
      this.$store.dispatch('submitQuery', { query: token, type: 'token' });
    },
    onCopy(e) {
      toast.copied(`${e.text.substring(0, 10)}...`);
    },
    onError(e) {
      this.$notify.error({
        title: 'Error',
        message: 'Failed to copy token',
        duartion: 10,
      });
    },
  },
};
</script>
